module.exports = __webpack_public_path__ + "img/poop.f95c8bd8.svg";